import { render, staticRenderFns } from "./web-marathon-add.vue?vue&type=template&id=2f93d3a6&scoped=true&"
import script from "./web-marathon-add.vue?vue&type=script&lang=js&"
export * from "./web-marathon-add.vue?vue&type=script&lang=js&"
import style0 from "./web-marathon-add.vue?vue&type=style&index=0&id=2f93d3a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f93d3a6",
  null
  
)

export default component.exports